import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'
import moment from 'moment-timezone'

export const AvailabilitySlotsState = {
  availabilitySlots: [],
}

export const AvailabilitySlotsActions = {
  async fetchAvailabilitySlots (_, { userIds, docketEntryTypeId }) {
    return axiosRequest.get('/calendar/availability_slots', {
      params: {
        docket_entry_type_id: docketEntryTypeId,
        user_ids: userIds,
      },
    }).
      then(({ data }) => {
        return data.map(s => {
          return {
            availabilityRuleId: s.availability_rule_id,
            docketEntryId: s.docket_entry_id,
            docketEntryTypeId: s.docket_entry_type_id,
            end_date: s.end_date,
            endDate: moment(s.end_date).format(),
            id: s.id,
            start_date: s.start_date,
            startDate: moment(s.start_date).format(),
            title: s.title,
            userId: s.user_id,
          }
        })
      }).
      catch(handleError)
  },

  async refreshAvailabilitySlots ({ commit, dispatch, state }) {
    state.runningRequests++

    return dispatch('fetchAvailabilitySlots', { userIds: [state.selectedCalendar.userId] }).
      then(slots => commit('updateAvailabilitySlots', slots)).
      catch(handleError).
      finally(_ => { state.runningRequests-- })
  },
}

export const AvailabilitySlotsMutations = {
  addAvailabilitySlots: (state, slots) => {
    state.availabilitySlots = state.availabilitySlots.concat(slots)
  },

  removeAvailabilitySlotsForRule: (state, ruleId) => {
    state.availabilitySlots = state.availabilitySlots.filter(s => s.availabilityRuleId !== ruleId)
  },

  replaceAvailabilitySlotsForRule: (state, { ruleId, slots }) => {
    state.availabilitySlots = state.availabilitySlots.filter(s => s.availabilityRuleId !== ruleId).concat(slots)
  },

  updateAvailabilitySlots: (state, slots) => {
    state.availabilitySlots = slots
  },
}

export const AvailabilitySlotsGetters = {
  availabilitySlots: state => state.availabilitySlots,
}
